<template>
  <!-- 资源库分类管理 -->
  <div class="layout">
    <div class="menu">
      <Menu topIndex="dataBase"></Menu>
    </div>
    <div class="leftSide">
      <LeftSideBar current="dataBase" leftIndex="sortManage"></LeftSideBar>
    </div>
    <div id="sortContent">
      <div class="left-tree">
        <div class="treeBox">
          <el-input
            class="subject-search-input"
            placeholder="请输入名称"
            v-model="treeSearchContent"
            style="margin-left: 10px"
          ></el-input>
          <el-tree
            v-if="opentree"
            ref="mainTree"
            class="structure-tree"
            :props="props"
            :load="loadNode"
            node-key="id"
            @node-click="listClick"
            highlight-current
            :expand-on-click-node="false"
            :filter-node-method="treeSearch"
            icon-class="el-icon-folder"
            :default-expanded-keys="['-1']"
            lazy
          >
          </el-tree>
        </div>
        <!-- <div>
          <el-input
            class="subject-search-input"
            placeholder="请输入名称"
          ></el-input>
          <el-button type="text" size="small" icon="el-icon-search">
          </el-button>
        </div> -->
      </div>
      <div class="rightBox">
        <!-- 上方按钮 -->
        <div class="button-box">
          <el-button
            type="text"
            @click="nodeEditSave"
            icon="el-icon-folder"
            size="small"
            :disabled="!(getAuthority.id > 0) || onclick == false"
            >保存</el-button
          >
          <el-button
            type="text"
            icon="el-icon-plus"
            size="small"
            @click="createSort()"
            :disabled="!(getAuthority.id > 0) || onclick == false"
            >新建子分类</el-button
          >
          <el-button
            type="text"
            icon="el-icon-delete"
            size="small"
            @click="checkPre('toDelete')"
            :disabled="!(getAuthority.id > 0) || onclick == false"
            >删除</el-button
          >
          <el-button
            type="text"
            icon="el-icon-unlock"
            size="small"
            @click="checkPre('toOn')"
            :disabled="!(getAuthority.id > 0) || onclick == false"
            >启用</el-button
          >
          <el-button
            type="text"
            icon="el-icon-lock"
            size="small"
            @click="checkPre('toOff')"
            :disabled="!(getAuthority.id > 0) || onclick == false"
            >停用</el-button
          >
          <el-button
            type="text"
            icon="el-icon-refresh"
            size="small"
            @click="checkPre('toOrder')"
            :disabled="!(getAuthority.id > 0) || onclick == false"
            >排序</el-button
          >
          <el-button
            type="text"
            icon="el-icon-sort"
            size="small"
            @click="checkPre('toMove')"
            :disabled="!(getAuthority.id > 0) || onclick == false"
            >移动</el-button
          >
        </div>
        <!-- 上方按钮end -->
        <div class="contentBox">
          <div
            v-show="getAuthority.id <= 0 || !getAuthority.id"
            class="tip-text"
          >
            请选择资源库
          </div>
          <div v-if="saveLoading == true" class="saveMessage">
            <i class="el-icon-loading"></i>正在{{ saveMessage }}中，请稍后
          </div>
          <!-- 新建子分类弹窗 -->
          <el-dialog
            title="新建子分类"
            :visible.sync="createSortDialog"
            width="600px"
          >
            <el-form
              ref="createSortForm"
              :model="createSortForm"
              :rules="createSortRules"
            >
              <el-form-item label="上级资源库:" label-width="100px">
                <el-input
                  type="text"
                  placeholder="未选择资源库"
                  :disabled="true"
                  v-model="currentParent"
                ></el-input>
              </el-form-item>
              <el-form-item label="资源库名称:" label-width="100px" prop="name">
                <el-input v-model="createSortForm.name" type="text"></el-input>
              </el-form-item>
              <el-form-item label="状态：" label-width="100px">
                <el-select v-model="createSortForm.status" clearable>
                  <el-option value="10" label="停用"> </el-option>
                  <el-option value="20" label="启用"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="来源：" label-width="100px">
                <el-select v-model="createSortForm.sourceId" clearable>
                  <el-option
                    v-for="item in sourceList"
                    :key="item.id"
                    :value="item.id"
                    :label="item.name"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="类型：" label-width="100px" prop="type">
                <el-select v-model="createSortForm.type" clearable>
                  <el-option
                    v-for="item in typeList"
                    :key="item.code"
                    :value="item.value"
                    :label="item.label"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="是否产品：" label-width="100px">
                <el-select v-model="createSortForm.isProd" clearable>
                  <el-option value="10" label="否"> </el-option>
                  <el-option value="20" label="是"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="备注：" label-width="100px">
                <el-input
                  type="textarea"
                  v-model="createSortForm.remark"
                  style="max-width: 400px"
                ></el-input>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="onCreate('createSortForm')"
                >确 定</el-button
              >
              <el-button @click="createSortDialog = false">取 消</el-button>
            </span>
          </el-dialog>
          <!-- 删除确认弹窗 -->
          <el-dialog
            title="删除分类"
            :visible.sync="deletePreDialog"
            width="600px"
          >
            <div>确定删除该分类</div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="onDelete" type="primary">确 定</el-button>
              <el-button @click="deletePreDialog = false">取 消</el-button>
            </span>
          </el-dialog>
          <!-- 启用分类弹窗 -->
          <el-dialog
            title="启用分类"
            :visible.sync="lockPreDialog"
            width="600px"
          >
            <div>确定启用该分类</div>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary">确 定</el-button>
              <el-button @click="lockPreDialog = false">取 消</el-button>
            </span>
          </el-dialog>
          <!-- 分类排序弹窗 -->
          <el-dialog
            class="reorderPreDialog"
            title="分类排序"
            :visible.sync="reorderPreDialog"
            width="600px"
          >
            <div>
              <span>移动</span
              ><el-input
                v-model="orderStep"
                id="orderStep"
                type="text"
              ></el-input
              ><span>位</span>
            </div>
            <div style="margin-top: 10px">
              填写<strong>正数</strong>表示向<span class="red">下</span
              >移动，<strong>负数</strong>表示向<span class="red">上</span>移动
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="reorder" type="primary">确 定</el-button>
              <el-button @click="reorderPreDialog = false">取 消</el-button>
            </span>
          </el-dialog>
          <!-- 分类移动弹窗 -->
          <el-dialog
            class="movePreDialog"
            title="移动分类"
            :visible.sync="movePreDialog"
            width="600px"
          >
            <div>
              <span>目标分类：</span>
              <el-select v-model="selectedValue" clearable>
                <el-option :value="dataList"
                  ><el-tree
                    ref="tree"
                    :props="props"
                    :load="loadNode"
                    check-on-click-node
                    highlight-current
                    :expand-on-click-node="false"
                    @check-change="handleCheckChange"
                    node-key="id"
                    lazy
                  >
                  </el-tree>
                </el-option>
              </el-select>
            </div>

            <span slot="footer" class="dialog-footer">
              <el-button @click="moveSort" type="primary">确 定</el-button>
              <el-button @click="movePreDialog = false">取 消</el-button>
            </span>
          </el-dialog>
          <!-- 分类编辑显示内容 -->
          <el-form
            :data="sortContentForm"
            v-show="getAuthority.id > 0"
            class="sortEditForm"
          >
            <el-form-item label="资源库/分类ID：" label-width="200px">
              <p>{{ sortContentForm.id }}</p>
            </el-form-item>
            <el-form-item
              v-model="sortContentForm.status"
              label="状态："
              label-width="200px"
            >
              <el-tag
                type="success"
                effect="dark"
                v-if="sortContentForm.status == 20"
                >启用</el-tag
              >
              <el-tag
                type="danger"
                effect="dark"
                v-if="sortContentForm.status == 10"
                >停用</el-tag
              >
            </el-form-item>
            <el-form-item label="资源库名称：" label-width="200px">
              <el-input
                v-model="sortContentForm.name"
                style="max-width: 400px"
              ></el-input>
            </el-form-item>
            <el-form-item label="来源：" label-width="200px">
              <el-select v-model="sortContentForm.sourceId" clearable>
                <el-option
                  v-for="item in sourceList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="类型：" label-width="200px">
              <el-select v-model="sortContentForm.type" clearable>
                <el-option
                  v-for="item in typeList"
                  :key="item.code"
                  :value="item.value"
                  :label="item.label"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否产品：" label-width="200px" clearable>
              <el-select v-model="formIsProd">
                <el-option value="10" label="否"> </el-option>
                <el-option value="20" label="是"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="备注：" label-width="200px">
              <el-input
                type="textarea"
                v-model="sortContentForm.remark"
                style="max-width: 400px"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from "../../menu/menu.vue";
import LeftSideBar from "../../menu/leftSideBar.vue";
import cookies from "vue-cookies";
import $ from "jquery";
export default {
  data: function () {
    return {
      getAuthority: {},
      treeSearchContent: "",
      formIsProd: "",
      onclick: true,
      saveLoading: false,
      currentNode: {},
      saveMessage: "",
      dataList: [],
      currentParent: "",
      // expandedId: "-1",
      orderStep: "",
      opentree: true,
      sourceList: [],
      moveToID: "",
      selectedValue: null,
      treeData: [],
      treeNode_had: [],
      treeResolve_had: [],
      sortContentForm: {
        id: "",
        name: "",
        innerCode: "",
        children: [],
        type: "",
        parentId: "",
        isProd: "",
        remark: "",
        status: "",
        sourceId: "",
        sourceInfo: {
          id: "",
          name: "",
        },
      },
      createSortForm: {
        name: "",
        type: "",
        parentId: "",
        remark: "",
        parentInnerCode: "",
        status: "",
        sourceId: "",
        sourceInfo: {
          id: "",
          name: "",
        },
      },
      typeList: [
        {
          label: "百科条目",
          value: 10,
        },
        {
          label: "辞典工具书",
          value: 20,
        },
        {
          label: "专项数据",
          value: 30,
        },
        {
          label: "图书",
          value: 40,
        },
        {
          label: "图片",
          value: 50,
        },
        {
          label: "音频",
          value: 60,
        },
        {
          label: "视频",
          value: 70,
        },
        {
          label: "图片集",
          value: 80,
        },
        {
          label: "音频集",
          value: 90,
        },
        {
          label: "图书",
          value: 30,
        },
        {
          label: "视频集",
          value: 100,
        },
        {
          label: "3D动画",
          value: 110,
        },
        {
          label: "论文",
          value: 120,
        },
        {
          label: "文章",
          value: 130,
        },
        {
          label: "问答对",
          value: 140,
        },
      ],
      props: {
        label: "name",
        children: "children",
        isLeaf: "leaf",
      },
      // 弹窗组
      createSortDialog: false,
      deletePreDialog: false,
      lockPreDialog: false,
      reorderPreDialog: false,
      movePreDialog: false,
      createSortRules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        type: [{ required: true, message: "请选择类型", trigger: "blur" }],
      },
    };
  },
  components: {
    Menu,
    LeftSideBar,
  },
  watch: {
    treeSearchContent(val) {
      this.$refs.mainTree.filter(val);
    },
  },
  mounted() {
    // 统一验证token
    var currentToken = cookies.get("token");
    $.ajaxSetup({
      headers: {
        AuthorizationToken: currentToken,
      },
      complete: function (xhr) {
        if (xhr.responseJSON.code == 401) {
          window.location.href = "/";
        }
      },
    });
  },
  methods: {
    // 树形结构加载
    loadNode(node, resolve) {
      let that = this;
      this.getAuthority = node;
      $.ajax({
        url: "/zyk/c/subject/subjectInfo/list?page=1&size=1000",
        type: "GET",
        //contentType: 'application/json;charset=utf-8',
        dataType: "json",
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function (data) {
          if (node.level == 0) {
            return resolve([{ name: "百科数据资源库", id: "-1" }]);
          } else if (node.level == 1) {
            this.treeNode_had = node;
            that.dataList = data.obj.list;
            return resolve(that.dataList);
          } else {
            $.ajax({
              url: "/zyk/c/subject/subjectInfo/list?page=1&size=1000",
              type: "GET",
              //contentType: 'application/json;charset=utf-8',
              data: { id: node.data.id },
              dataType: "json",
              error: function (xhr) {
                if (xhr.status == 401) {
                  window.location.reload();
                }
              },
              success: function (data) {
                return resolve(data.obj.list);
              },
            });
          }
        },
      });
    },
    // 点击树
    listClick(node) {
      let that = this;
      that.getAuthority = node;
      if (node.id == -1) {
        that.sortContentForm = {
          id: "-1",
          name: "百科数据资源库",
        };
      } else {
        that.getSourceList();
        that.sortContentForm = node;
        if (that.sortContentForm.isProd != null) {
          that.formIsProd = that.sortContentForm.isProd.toString();
        }else{
          that.formIsProd = null;
        }
      }
    },
    // 修改节点保存
    nodeEditSave() {
      let that = this;
      that.onclick = false;
      that.saveLoading = true;
      that.saveMessage = "保存";
      that.sortContentForm.isProd = this.formIsProd;
      $.ajax({
        url: "/zyk/c/subject/subjectInfo/update",
        type: "POST",
        //contentType: 'application/json;charset=utf-8',
        dataType: "json",
        data: that.sortContentForm,
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function (data) {
          if (data.code == 200) {
            that.$message({
              message: "修改成功",
              duration: 2000,
              showClose: true,
              type: "success",
              offset: 100,
            });
            that.onclick = true;
            that.saveLoading = false;
            that.$refs.mainTree.updateKeyChildren(
              that.sortContentForm.id,
              that.sortContentForm
            );
          } else {
            that.onclick = false;
            that.$message({
              message: data.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
      });
    },
    // 创建子分类
    createSort() {
      let that = this;
      that.createSortForm = {
        name: "",
        type: "",
        parentId: "",
        parentInnerCode: "",
        remark: "",
        status: "",
        sourceId: "",
      };
      that.currentParent = that.sortContentForm.name;
      that.createSortForm.parentId = that.sortContentForm.id;
      that.createSortForm.parentInnerCode = that.sortContentForm.innerCode;
      this.createSortDialog = true;
      that.getAuthority = {};
    },
    // 提交创建
    onCreate(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this;
          $.ajax({
            url: "/zyk/c/subject/subjectInfo/add",
            type: "POST",
            //contentType: 'application/json;charset=utf-8',
            dataType: "json",
            data: that.createSortForm,
            error: function (xhr) {
              if (xhr.status == 401) {
                window.location.reload();
              }
            },
            success: function (data) {
              if (data.code == 200) {
                 var updateNode = {}
                if(that.$refs.mainTree.getNode(that.sortContentForm).level>1){
                    updateNode = that.$refs.mainTree.getNode(that.sortContentForm.parentId).data
                }else{
                    updateNode = that.sortContentForm
                }
                $.ajax({
                  url: "/zyk/c/subject/subjectInfo/list?page=1&size=1000",
                  type: "GET",
                  //contentType: 'application/json;charset=utf-8',
                  // data: { id: that.sortContentForm.parentId },
                  data: { id: updateNode.id },
                  dataType: "json",
                  error: function (xhr) {
                    if (xhr.status == 401) {
                      window.location.reload();
                    }
                  },
                  success: function (response) {
                    updateNode.children = response.obj.list
                    that.$refs.mainTree.updateKeyChildren(
                      updateNode.id,
                      updateNode
                    );
                  },
                });
                that.$message({
                  message: "新增成功",
                  duration: 2000,
                  showClose: true,
                  type: "success",
                  offset: 100,
                });
                that.createSortDialog = false;
              } else {
                that.$message({
                  message: data.msg,
                  duration: 0,
                  showClose: true,
                  type: "error",
                  offset: 100,
                });
              }
            },
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 获取来源list
    getSourceList() {
      let that = this;
      $.ajax({
        type: "GET",
        dataType: "json",
        data: {
          page: 1,
          size: 1000,
        },
        url: "/zyk/c/source/sourceInfo/list",
        success: function (response) {
          if (response.code == 200) {
            that.optionData = response.obj.list;
            if (response.obj && response.obj.list.length == 0) {
              that.dataText = "暂无数据";
            }
            that.sourceList = response.obj.list;
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },
    // 删除、启停用、排序前确认
    checkPre(current) {
      let that = this;
      let ids = this.sortContentForm.id;
      if (!that.getAuthority.id || that.getAuthority.id == "-1") {
        that.$message({
          message: "请选中权限再进行操作",
          duration: 2000,
          showClose: true,
          type: "error",
          offset: 100,
        });
      } else if (current == "toDelete") {
        this.deletePreDialog = true;
      } else if (current == "toOn") {
        if (this.sortContentForm.status == 10) {
          that.onclick = false;
          that.saveLoading = true;
          that.saveMessage = "启用";
          console.log(that.sortContentForm.children);
          $.ajax({
            url: "/zyk/c/subject/subjectInfo/onoff",
            type: "POST",
            //contentType: 'application/json;charset=utf-8',
            dataType: "json",
            data: { ids: ids, status: 20 },
            error: function (xhr) {
              this.onclick = true;
              if (xhr.status == 401) {
                window.location.reload();
              }
            },
            success: function () {
              that.onclick = true;
              that.saveLoading = false;
              that.sortContentForm.status = 20;
              that.$refs.mainTree.store.nodesMap[ids].expanded = false;
              that.$refs.mainTree.store.nodesMap[ids].loaded = false;
            },
          });
        } else {
          that.$message({
            message: "已经是启用状态，无需再次启用",
            duration: 2000,
            showClose: true,
            type: "error",
            offset: 100,
          });
        }
      } else if (current == "toOff") {
        if (this.sortContentForm.status == 20) {
          that.onclick = false;
          that.saveLoading = true;
          that.saveMessage = "停用";
          console.log(that.sortContentForm.children);
          $.ajax({
            url: "/zyk/c/subject/subjectInfo/onoff",
            type: "POST",
            //contentType: 'application/json;charset=utf-8',
            dataType: "json",
            data: { ids: ids, status: 10 },
            error: function (xhr) {
              that.onclick = true;
              if (xhr.status == 401) {
                window.location.reload();
              }
            },
            success: function () {
              that.onclick = true;
              that.saveLoading = false;
              that.sortContentForm.status = 10;
              that.$refs.mainTree.store.nodesMap[ids].expanded = false;
              that.$refs.mainTree.store.nodesMap[ids].loaded = false;
            },
          });
        } else {
          that.$message({
            message: "已经是停用状态，无需再次停用",
            duration: 2000,
            showClose: true,
            type: "error",
            offset: 100,
          });
        }
      } else if (current == "toOrder") {
        this.reorderPreDialog = true;
      } else if (current == "toMove") {
        this.movePreDialog = true;
      }
    },
    // 删除
    onDelete() {
      let ids = this.sortContentForm.id;
      let that = this;
      // that.noClick = true;
      $.ajax({
        url: "/zyk/c/subject/subjectInfo/remove",
        type: "POST",
        //contentType: 'application/json;charset=utf-8',
        dataType: "json",
        data: { ids: ids },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function (data) {
          if (data.code == 200) {
            that.$message({
              message: "删除成功",
              duration: 2000,
              showClose: true,
              type: "success",
              offset: 100,
            });
            var updateNode = {}
            if(that.$refs.mainTree.getNode(that.sortContentForm).level>1){
                updateNode = that.$refs.mainTree.getNode(that.sortContentForm.parentId).data
            }else{
                updateNode = that.sortContentForm
            }
            $.ajax({
              url: "/zyk/c/subject/subjectInfo/list?page=1&size=1000",
              type: "GET",
              //contentType: 'application/json;charset=utf-8',
              // data: { id: that.sortContentForm.parentId },
              data: { id: updateNode.id },
              dataType: "json",
              error: function (xhr) {
                if (xhr.status == 401) {
                  window.location.reload();
                }
              },
              success: function (response) {
                updateNode.children = response.obj.list
                that.$refs.mainTree.updateKeyChildren(
                  updateNode.id,
                  updateNode
                );
              },
            });
            that.deletePreDialog = false;
          } else {
            that.$message({
              message: data.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
      });
    },
    // 排序
    reorder() {
      let id = this.sortContentForm.id;
      let that = this;
      console.log(this.orderStep);
      $.ajax({
        url: "/zyk/subject/orderSubject",
        type: "POST",
        //contentType: 'application/json;charset=utf-8',
        dataType: "json",
        data: { id: id, step: this.orderStep },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function () {
          that.opentree = false;
          that.$nextTick(() => {
            that.opentree = true;
          });
          that.reorderPreDialog = false;
        },
      });
    },
    moveSort() {
      let that = this;
      let params = {
        sourceId: this.sortContentForm.id,
        targetId: this.moveToID,
      };
      $.ajax({
        url: "/zyk/subject/moveSubject",
        type: "POST",
        //contentType: 'application/json;charset=utf-8',
        data: params,
        dataType: "json",
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function (data) {
          if (data.code == 200) {
            that.$message({
              message: "移动成功",
              duration: 2000,
              showClose: true,
              type: "success",
              offset: 100,
            });
            that.opentree = false;
            that.$nextTick(() => {
              that.opentree = true;
            });
            that.movePreDialog = false;
          } else {
            that.$message({
              message: data.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
      });
    },
    // 左侧树搜索
    treeSearch(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    handleCheckChange() {
      let res = this.$refs.tree.getCurrentNode();
      this.selectedValue = res.name;
      this.moveToID = res.id;
    },
    deletePre() {
      this.deletePreDialog = true;
    },
    lockPre() {
      this.lockPreDialog = true;
    },
    reorderPre() {},
  },
};
</script>

<style>
#sortContent {
  clear: both;
  margin-top: -8px;
  margin-left: 170px;
}

.rightBox {
  float: right;
  width: calc(100% - 250px);
  margin-top: 95px;
}
.information {
  width: 100%;
}

.el-dialog .el-form {
  padding: 10px 50px;
}

.reorderPreDialog {
  text-align: center;
}

.left-tree span.el-tree-node__label {
  text-overflow: initial !important;
}

.reorderPreDialog .el-input {
  display: inline;
}
.reorderPreDialog input {
  width: 100px;
}
.reorderPreDialog .red {
  color: red;
}
.sortEditForm label {
  text-align: left;
}

.sortEditForm {
  padding: 10px 50px;
}

.sortEditForm .el-form-item {
  display: block;
  margin: 15px 0 !important;
}

.rightBox .contentBox {
  position: relative;
}

.rightBox .contentBox .saveMessage {
  position: absolute;
  width: 650px;
  height: 410px;
  background-color: rgba(255, 255, 255, 0.8);
  text-align: center;
  top: 0;
  left: 0;
  z-index: 10;
}
</style>